import { render, staticRenderFns } from "./BulkTechnician.vue?vue&type=template&id=a3fe42d4&scoped=true"
import script from "./BulkTechnician.vue?vue&type=script&lang=js"
export * from "./BulkTechnician.vue?vue&type=script&lang=js"
import style0 from "./BulkTechnician.vue?vue&type=style&index=0&id=a3fe42d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fe42d4",
  null
  
)

export default component.exports